// import User from '@/types/User'
import { defineStore } from 'pinia'

type Theme = 'light' | 'dark' | 'auto'

export const useGeneralStore = defineStore('general', {
    state: () => {
        return {
            user: {} as any,
            sendbird: { nickname: '', token: '' },
            telescopeUrl: '',
            horizonUrl: '',
            resourceHash: localStorage.getItem('resourceHash'),
            isInitCompleted: false,
            isGoogleScriptLoaded: false,
            hasInteracted: false,
            theme: (localStorage.getItem('theme') as Theme) || 'light'
        }
    },
    actions: {
        setUserInteracted() {
            this.hasInteracted = true
        },
        setTheme(theme: Theme) {
            this.theme = theme
            localStorage.setItem('theme', theme)
            this.applyTheme()
        },
        applyTheme() {
            const body = document.body

            body.classList.remove('theme-light', 'theme-dark')

            let appliedTheme = this.theme

            if (this.theme === 'auto') {
                const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
                appliedTheme = prefersDark ? 'dark' : 'light'
            }

            body.classList.add(`theme-${appliedTheme}`)

            if (appliedTheme === 'dark') {
                body.classList.add('theme-dark')
            }

            document.documentElement.setAttribute('data-bs-theme', appliedTheme)
        },
        initTheme() {
            this.applyTheme()

            if (this.theme === 'auto') {
                window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
                    if (this.theme === 'auto') {
                        this.applyTheme()
                    }
                })
            }
        }
    }
})
